import { API } from "../../../utils";

export const getTenantLinkSettingsApi = async () => {
  const res = await API.get("/settings/links");
  return res.data;
};

export const updateTenantLinkSettingsApi = async (payload) => {
  const res = await API.put("/settings/links", payload);
  return res.data;
};
